import { produce } from 'immer'
import {
  SET_DARK_MODE,
  SET_LIGHT_MODE,
  SET_DOWNLOAD_BANNER_SIZE,
  SET_DOWNLOAD_BANNER_VISIBILITY,
} from '../actions/app'

const initialState = {
  loaded: false,
  isDarkMode: true,
  showDownloadBanner: {
    isBannerVisible: true,
    isSmall: false,
    isBig: true,
  },
}

export default (state = initialState, { type, payload }) =>
  produce(state, (draft) => {
    switch (type) {
      case 'APP_LOADED':
        draft.loaded = true
        break
      case SET_DARK_MODE:
        draft.isDarkMode = true
        break
      case SET_LIGHT_MODE:
        draft.isDarkMode = false
        break
      case SET_DOWNLOAD_BANNER_SIZE: {
        const size = payload
        draft.showDownloadBanner.isSmall = size === 'small'
        draft.showDownloadBanner.isBig = size === 'big'
        break
      }
      case SET_DOWNLOAD_BANNER_VISIBILITY:
        draft.showDownloadBanner.isBannerVisible = payload
        break
      default:
        break
    }
  })
